module.exports = __webpack_public_path__ + "assets/img/sabc_video_playicon.webp?27499b815d42d865f282cd612651a75a";